<template>
	<div class="container check-eds">
		<div class="check-eds__title mb-30">Данный электронный документ подписан с использованием электронной цифровой подписи</div>
		<div class="check-eds__text">Для проверки электронного документа отсканируйте QR код либо перейдите по ссылке:</div>
		<a :href="url" target="_blank" class="check-eds__text mb-30">{{url}}</a>

		<div class="check-eds__row">
			<div class="check-eds__qrcode-wrap">
				<qrcode :value="url" class="check-eds__qrcode-img"/>
			</div>
			<div class="check-eds__descr">
				Данный документ согласно пункту 1 статьи 7 ЗРК от 7 января 2003 года N370-
				II «Об электронном документе и электронной цифровой подписи»,
				удостоверенный посредством электронной цифровой подписи лица,
				имеющего полномочия на его подписание, равнозначен подписанному
				документу на бумажном носителе.
			</div>
		</div>

		<div class="check-eds__table">
			<div class="check-eds__row">
				<div class="check-eds__label">Тип документа</div>
				<div class="check-eds__value">{{typeDocument}}</div>
			</div>
			<div class="check-eds__row">
				<div class="check-eds__label">Номер документа</div>
				<div v-if="!isExtendedType" class="check-eds__value">{{numberDocument}}</div>
				<div v-if="isExtendedType" class="check-eds__value">{{numberOrder}}</div>
			</div>
			<div class="check-eds__row">
				<div class="check-eds__label">Цифровые подписи</div>
				<div class="check-eds__value">
					<ul v-if="!isExtendedType" class="check-eds__signatures">
						<li>
							<div>
								<strong>Подписант:</strong> {{ employeeData }}</div>
							<div>
								<strong>Дата подписания:</strong> {{ employeeSignDate }}</div>
						</li>
					</ul>

					<ul v-if="isExtendedType" class="check-eds__signatures">
						<li>
							<div>
								<strong>Подпись сотрудника:</strong> {{ employeeData }}</div>
							<div>
								<strong>Дата подписания:</strong> {{ employeeSignDate }}</div>
						</li>
						<li>
							<div>
								<strong>Подпись руководителя:</strong> {{ curatorData }}</div>
							<div>
								<strong>Дата подписания:</strong> {{ curatorSignDate }}</div>
						</li>
					</ul>

					<div>
						<strong>Компания:</strong> Акционерное общество "Страховая Компания "Сентрас
						Иншуранс"
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
  
<script>
import Qrcode from 'vue-qrcode';
import { computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';

export default {
	components: {
		Qrcode
	},

	setup() {
		const store = useStore();
		const count = ref(0);
		const cdn = computed(() => store.state.cdn);
		const error = ref(null);

		const isExtendedType = ref(false);

		const numberDocument = ref('');
		const typeDocument = ref('');

		const numberOrder = ref("");

		const employeeData = ref("");
		const employeeSignDate = ref("");

		const curatorData = ref("");
		const curatorSignDate = ref("")

		const url = ref("")

		const docISN = new URLSearchParams(window.location.search).get('docISN');
		const subjISN = new URLSearchParams(window.location.search).get("subjISN");
		const orderNo = new URLSearchParams(window.location.search).get("orderNo");

		if (subjISN && orderNo) {
			isExtendedType.value = true;

			url.value = `https://cic.kz/check-eds/?docISN=${docISN}&subjISN=${subjISN}&orderNo=${orderNo}`
		} else {
			url.value = `https://cic.kz/check-eds/?docISN=${docISN}`
		}

		onMounted(async () => {
			try {
				const {data} = await axios.get(`V1/sign-verify?docISN=${docISN}&subjISN=${subjISN}&orderNo=${orderNo}`);

				typeDocument.value = data.data.signers.doc_type;

				console.log(data, isExtendedType.value);

				if (isExtendedType.value) {
					numberOrder.value = data.data.signers.order_number;

					employeeData.value = data.data.signers.employee_fio;
					employeeSignDate.value = data.data.signers.employee_sign_date;
					
					curatorData.value = data.data.signers.curator_fio;
					curatorSignDate.value = data.data.signers.curator_sign_date;
				} else {
					console.log(123);
					numberDocument.value = data.data.signers.doc_number;

					employeeData.value = data.data.signers.signer_fio;
					employeeSignDate.value = data.data.signers.sign_date;
				}

				console.log(employeeData.value, employeeSignDate.value, numberDocument.value)
			} catch (err) {
				console.error('API error:', err);
				error.value = 'Ошибка при получении данных проверки';
			}
		});

		return {
			count,
			url,
			cdn,
			numberDocument,
			typeDocument,
			isExtendedType,
			numberOrder,
			employeeData,
			employeeSignDate,
			curatorData,
			curatorSignDate
		}
	}
}
</script>
  
<style lang="scss" scoped>
ul {
	list-style: none !important;
	padding: 0 !important;
	margin: 0;
}
.check-eds {
	padding: 30px;

	&__title {
		font-size: 20px;
		font-weight: 500;
	}
	&__text {
		font-size: 20px;
		font-weight: 500;
	}
	&__row {
		display: flex;
		flex-wrap: wrap;
	}
	&__descr {
		font-size: 19px;
		font-weight: 500;
		padding: 30px 15px;
		flex: 1;
	}
	&__qrcode-wrap {
		width: 100%;
		max-width: 250px;
		aspect-ratio: 1 / 1;
	}

	&__qrcode-img {
		width: 100%;
		height: auto;
		display: block;
	}
}

.mb-30 {
	margin-bottom: 30px;
}

@media (max-width: 600px) {
	.check-eds {
		padding: 20px;

		&__title,
		&__text,
		&__descr {
			font-size: 16px;
		}

		&__row {
			flex-direction: column;
			align-items: center;
		}

		&__qrcode-wrap {
			max-width: 200px;
		}
	}
}


.check-eds__table {
	border: 1px solid #ccc;
	border-radius: 8px;
	overflow: hidden;
	margin-top: 30px;

	.check-eds__row {
		display: flex;
		justify-content: space-between;
		padding: 15px 20px;
		border-bottom: 1px solid #eee;

		&:nth-child(even) {
			background-color: #fff;
		}

		&:last-child {
			border-bottom: none;
		}
	}

	.check-eds__label {
		flex: 1;
		font-weight: 600;
		font-size: 18px;
		color: #333;
	}

	.check-eds__value {
		flex: 2;
		font-size: 18px;
		color: #444;
		word-break: break-word;
	}

	.check-eds__signatures {
		margin: 0;
		padding-left: 20px;
		list-style-type: disc;
	}
}

.check-eds__error {
	margin-top: 20px;
	color: #ff4d4f;
	font-weight: 500;
	background: #fff0f0;
	padding: 12px 16px;
	border: 1px solid #ffa39e;
	border-radius: 6px;
}

@media (max-width: 600px) {
	.check-eds__table .check-eds__row {
		flex-direction: column;
		gap: 8px;
	}
}

</style>